import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = { class: "flex flex-col items-center text-center justify-center h-full px-5" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    class: "w-60 max-w-full pointer-events-none select-none",
    src: "/img/school/components/Messages/ContentSide/empty-bg.png",
    srcset: "\n                 /img/school/components/Messages/ContentSide/empty-bg.png 1x,\n                 /img/school/components/Messages/ContentSide/empty-bg@2x.png 2x\n            "
}, null, -1);
var _hoisted_3 = { class: "mt-5 text-3xl font-medium" };
var _hoisted_4 = {
    key: 0,
    class: "mt-5 max-w-lg"
};
var _hoisted_5 = {
    key: 1,
    class: "mt-5 max-w-lg"
};
import { computed } from 'vue';
import { ChatStore, CoreStore } from '@common/stores';
import { AuthRoles } from '@common/interfaces/utils';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Empty',
    setup: function (__props) {
        var t = useI18n().t;
        var chatLoading = computed(function () { return ChatStore.contentChatLoading; });
        var user = computed(function () { return CoreStore.user; });
        return function (_ctx, _cache) {
            var _directive_loading = _resolveDirective("loading");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('messages.selectDialog')), 1),
                (user.value.role === _unref(AuthRoles).ROLE_STUDENT)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('messages.studentInfo')), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)('messages.teacherInfo')), 1))
            ])), [
                [_directive_loading, chatLoading.value]
            ]);
        };
    }
});
